module.exports = __webpack_public_path__ + "img/智能门控系统.660c9213.png";